@if (!hideIcon()) {
  <svg class="icon" [lucideIcon]="icon()" [size]="20"></svg>
}
@if (message()) {
  <span joii-text [color]="contentColor()">{{ message() }}</span>
}
<ng-content></ng-content>
@if (!hideClose()) {
  <svg class="icon close-icon" [lucideIcon]="closeIcon()" [size]="20" (click)="handleClose($event)"></svg>
}
